import { AfterViewInit, Component, ElementRef, forwardRef, Input, OnChanges, OnDestroy, OnInit, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { from, fromEvent, Observable, Subject } from 'rxjs';


@Component({
    selector: 'doc-form-textarea',
    templateUrl: 'textarea.component.html',
    styleUrls: ['textarea.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DocTextareaComponent),
        multi: true
    }]
})

export class DocTextareaComponent implements ControlValueAccessor, OnInit, AfterViewInit, OnDestroy, OnChanges {
    private onDestroyed$ = new Subject();

    @ViewChild('inputEl') inpulEl: ElementRef;

    @Input() parentForm: UntypedFormGroup;
    @Input() controlName: string;

    @Input() placeholder = '';
    @Input() label = '';

    @Input() maxRows = 5;
    @Input() minRows = 5;
    @Input() autoResize = true;

    @Input() boldLabel = false;

    value: string = '';
    changed = (value: any) => { };
    touched = () => { };
    disabled: boolean;

    constructor() { }

    ngOnInit(): void { }

    ngAfterViewInit() { }

    ngOnChanges(changes: SimpleChanges) { }

    writeValue(value: any): void {
        this.value = value ? value : '';
    }
    registerOnChange(fn: any): void {
        this.changed = fn;
    }
    registerOnTouched(fn: any): void {
        this.touched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    ngOnDestroy() {
        this.onDestroyed$.next();
        this.onDestroyed$.complete();
    }
}

